import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { TransferSnReceivingErrors } from 'src/redux/slices/stock-transfer';
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tooltip
} from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import CachedIcon from '@material-ui/icons/Cached';
import useUserInfo from 'src/hooks/user/use-user-info';

interface Props {
  onClearAll: () => void;
  onRetry: (params: TransferSnReceivingErrors) => void;
  onRemove: (sn?: string) => void;
  isLoading?: boolean;
  transferSnErrorList?: TransferSnReceivingErrors[];
}

const Component = ({
  transferSnErrorList = [],
  isLoading = false,
  onRetry,
  onRemove,
  onClearAll
}: Props) => {
  const { userBranchNameViaId } = useUserInfo();

  return (
    <Box>
      {transferSnErrorList.length > 0
        ? transferSnErrorList?.map((errorSN, index) => (
            <Alert
              style={{ marginBottom: 1 }}
              key={`${errorSN?.serial_no}${index}`}
              severity="error"
              action={
                <div>
                  <Tooltip title="Retry" placement="top">
                    <IconButton
                      aria-label="retry"
                      color="inherit"
                      size="medium"
                      disabled={isLoading}
                      onClick={() => {
                        onRetry(errorSN);
                      }}
                    >
                      {isLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <CachedIcon fontSize="inherit" />
                      )}
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Remove" placement="top">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="medium"
                      disabled={isLoading}
                      onClick={() => {
                        onRemove(errorSN?.serial_no);
                      }}
                    >
                      <DeleteOutlineIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
                </div>
              }
            >
              <AlertTitle>
                {errorSN?.serial_no} - {userBranchNameViaId(errorSN?.branch_id)}
              </AlertTitle>
            </Alert>
          ))
        : null}
      {transferSnErrorList.length > 0 ? (
        <Box display="flex" justifyContent="flex-end">
          <Button onClick={onClearAll} color="secondary" disabled={isLoading}>
            Clear All Invalid Scanned Serial No(s)
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export const TransferSnListError = React.memo(Component);
